import { z } from 'zod';

import { zodAddressSchema } from '@vestigas/data';

import { zodSupplierObjectSchema } from '../validations';

/**
 * Zod schema for a supplier entry in either the high- or regular-priority list.
 * Both lists now share the same shape (PriorityItem).
 */
export const zodPriorityItemSchema = z.object({
  // Sibling fallback for `supplier.address`: this endpoint does not yet
  // populate the nested field, only this top-level one (unlike
  // /suppliers/network and /suppliers/overview, where the nested field is
  // the populated, canonical one). See `usePrioritizationState`'s
  // `withSupplierAddress`, which reconciles the two.
  address: zodAddressSchema.nullish(),
  dataExchangeId: z.uuid(),
  score: z.number().int().nonnegative(),
  supplier: zodSupplierObjectSchema,
});

/**
 * Zod schema for the query parameters for the GET /suppliers/priority request.
 */
export const zodSuppliersPrioritySearchParamsSchema = z.object({
  recipientCompanyId: z.uuid(),
});

/**
 * Zod schema for the GET /PUT /suppliers/priority response (PriorityListResponse).
 */
export const zodSuppliersPriorityResponseSchema = z.object({
  highPriority: z.array(zodPriorityItemSchema),
  highPrioritySlotsRemaining: z.number().int().nonnegative(),
  highPrioritySlotsTotal: z.number().int().nonnegative(),
  highPrioritySlotsUsed: z.number().int().nonnegative(),
  regularPriority: z.array(zodPriorityItemSchema),
});
